import { NavLink } from 'react-router-dom';

import classes from './SiteNavigation.module.css';

function LitigationMenu(props) {
  return (
    <>
      <nav>
        <ul>
          <li>
            <NavLink
              to="/"
              onClick={props.closeMenu}
              className={({ isActive }) =>
                isActive ? classes.active : undefined
              }
              end
            >
              Litigation Service 1
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/"
              onClick={props.closeMenu}
              className={({ isActive }) =>
                isActive ? classes.active : undefined
              }
              end
            >
              Litigation Service 2
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/"
              onClick={props.closeMenu}
              className={({ isActive }) =>
                isActive ? classes.active : undefined
              }
              end
            >
              Litigation Service 3
            </NavLink>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default LitigationMenu;
